import React from 'react';
import { ArticleLayout } from '../../components/ArticleLayout';

export const ExcelMemoQArticle: React.FC = () => {
    return (
        <ArticleLayout
            title="Excel to MemoQ: A Streamlined Approach"
            subtitle="Enhance your MemoQ localization projects with better Excel preparation."
        >
            <h3>MemoQ's Excel Capabilities</h3>
            <p>
                MemoQ offers a robust Excel filter, allowing for chaining and regex tagging. However, configuring these filters
                for every project can be time-consuming and error-prone, especially for project managers handling multiple file formats.
            </p>

            <h3>Simplifying with XLIFF</h3>
            <p>
                Standardizing on XLIFF reduces the complexity within MemoQ. Instead of creating complex filter configurations
                for each Excel sheet, you simply import a standard XLIFF file. MemoQ handles XLIFF natively and perfectly.
            </p>

            <h3>Handling Multilingual Excels</h3>
            <p>
                If your Excel file contains source text in Column A and you need to translate into French (Column B) and German (Column C),
                our converter can generate separate XLIFF files for each target language.
                After translation, you can merge them all back into the single Excel file, populating the respective columns automatically.
            </p>
        </ArticleLayout>
    );
};
